import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <main className="screen">
      <div className="card">
        <h1 className="card__title">{t("notFound.title")}</h1>
        <Link className="link" to="/">
          {t("notFound.back")}
        </Link>
      </div>
    </main>
  );
}
